
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.267 9.53a1.81 1.81 0 00-2.068.183l-1.364-.788a2.971 2.971 0 000-1.85l1.365-.788a1.807 1.807 0 10.26-2.949 1.808 1.808 0 00-.878 1.882l-1.365.788a2.983 2.983 0 00-1.6-.926V3.507a1.81 1.81 0 001.19-1.7A1.81 1.81 0 008 0a1.81 1.81 0 00-1.808 1.808c0 .78.498 1.446 1.192 1.699v1.575a2.983 2.983 0 00-1.601.926L4.418 5.22a1.801 1.801 0 00-.035-.784 1.807 1.807 0 10-.583 1.85l1.366.789a2.972 2.972 0 000 1.85L3.8 9.713a1.807 1.807 0 10-.26 2.949 1.808 1.808 0 00.877-1.882l1.365-.788c.415.461.972.793 1.6.926v1.575a1.81 1.81 0 00-1.19 1.7C6.192 15.188 7.002 16 8 16a1.81 1.81 0 001.808-1.808 1.81 1.81 0 00-1.192-1.699v-1.575a2.983 2.983 0 001.601-.926l1.365.788a1.808 1.808 0 102.685-1.25zm-1.192-5.124a.575.575 0 11.576.995.575.575 0 01-.576-.995zm-9.94.785a.576.576 0 11-.996-.576.576.576 0 01.996.576zm-.21 6.403a.575.575 0 11-.576-.995.575.575 0 01.576.995zM8 1.232A.576.576 0 118 2.384.576.576 0 018 1.232zm0 13.536a.576.576 0 11.001-1.152.576.576 0 010 1.152zM8 9.75c-.965 0-1.75-.785-1.75-1.75S7.035 6.25 8 6.25 9.75 7.035 9.75 8 8.965 9.75 8 9.75zm5.861 1.634a.575.575 0 11-.996-.575.575.575 0 01.996.575z","fill":"#6C6C6C"}})])
          )
        }
      }
    